"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = exports.IconSize = exports.IconColor = void 0;
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var tokens = exports.tokens = {
  size: {
    s: '16px',
    m: '20px',
    l: '24px'
  },
  color: {
    default: _globalTokens.globalColor.iconFill.onLight,
    error: _globalTokens.globalColor.iconFill.error,
    warning: _globalTokens.globalColor.iconFill.warning,
    success: _globalTokens.globalColor.iconFill.success,
    white: _globalTokens.globalColor.iconFill.onDark,
    primary: _globalTokens.globalColor.iconFill.primary,
    disabled: _globalTokens.globalColor.iconFill.disabled,
    disabledOnDisabled: _globalTokens.globalColor.iconFill.onDisabled,
    secondary: _globalTokens.globalColor.iconFill.secondary
  },
  newColor: _tokens.default.sky.sys.color.iconfill
};
var IconColor = exports.IconColor = /*#__PURE__*/function (IconColor) {
  IconColor["default"] = "default";
  IconColor["error"] = "error";
  IconColor["warning"] = "warning";
  IconColor["success"] = "success";
  IconColor["white"] = "white";
  IconColor["primary"] = "primary";
  IconColor["disabled"] = "disabled";
  IconColor["disabledOnDisabled"] = "disabledOnDisabled";
  IconColor["secondary"] = "secondary";
  return IconColor;
}({});
var IconSize = exports.IconSize = /*#__PURE__*/function (IconSize) {
  IconSize["s"] = "s";
  IconSize["m"] = "m";
  IconSize["l"] = "l";
  return IconSize;
}({});